import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import bookmaker from '../../assets/icons/bookmaker-svgrepo-com.svg'
import next from '../../assets/icons/back-svgrepo-com.svg'
import ImageWithFallback from '../ImageWithFallback'
import {formatDate} from "../../../components/DateTimeConverter/DateTimeConverter"
import { END_POINT } from '../../../utils/constant'
import TruncateText from '../../../components/TruncateText'
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/fr"; // Importer la locale française

dayjs.extend(relativeTime);
dayjs.locale("fr");


const FormationCard = ({item}) => {
    const navigate = useNavigate()
  return (
    <div onClick={()=>navigate("/formation/"+item?.id)}  className='bg-white rounded-lg overflow-hidden border transition-all ease-in hover:scale-[1.01] hover:shadow-md cursor-pointer'>
        <div className=' flex flex-col sm:flex-row gap-4 text-start p-4'>
            <div className=' bg-slate-50 rounded-sm flex items-center justify-center min-w-[350px] max-w-[350px] max-h-56 '>
              <ImageWithFallback src={END_POINT+"/storage"+item?.image} className=" bg-fit bg-top w-full object-cover " defaultType="training"/>
            </div>

            <div className='flex flex-col justify-between gap-y-2 w-full'>
              <p className='text-level-1 flex-col justify-between col'>
                <div className='font-semibold text-lg'>{item?.title}</div>
                <div className="flex items-center gap-2">
                  <ImageWithFallback src={END_POINT+"/storage"+item?.user?.organisation_profile?.logo} className="  object-cover bg-neutral-100 rounded-full w-8 h-8" defaultType="logo"/>
                  <div>{item?.user?.organisation_profile?.company_name}</div>
                </div> 
              </p>

              <div className="flex gap-x-2 text-primary-text">
                <div className="font-medium p-2 rounded-md bg-gray-50 border-slate-100">
                  {item?.type}
                </div>
                <div className="font-medium p-2 rounded-md bg-gray-50 border-slate-100">
                  {item?.duration}
                </div>
                <div className="font-medium p-2 rounded-md bg-gray-50 border-slate-100">
                  {item?.fees}
                </div>
              </div>
              <TruncateText maxChars={150} className='mb-2 hidden sm:block' isDangerousHtml>{item?.description}</TruncateText>
              <div className="flex justify-between items-center">
                  <p> il y a {dayjs(item?.created_at).fromNow(true)}</p>
                  <button className='bg-primary-green border-none rounded-sm text-[#145926] font-semibold text-sm px-4 py-2 flex gap-2 items-center'>Je m'informe <img src={next} alt="" className='w-4 rotate-180' /></button>
              </div>
            </div>
        </div>

    </div >
  )
}

export default FormationCard